import { RouteUtils } from "@rsm-hcd/javascript-core";
import { NotebookConstants } from "constants/notebook-constants";
import { siteMap } from "internal-sitemap";
import { useCallback } from "react";
import { useHistory } from "react-router";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";
import useLastVisitedNotebook from "utilities/hooks/domain/notebooks/use-last-visited-notebook";
import useNotebooksAtom from "utilities/hooks/domain/notebooks/use-notebooks-atom";

interface UseNotebooksRedirects {
    redirectToDefaultNotebook: () => void;
    redirectToDefaultNotebookAfterDelete: (deletedNotebookId: number) => void;
    redirectToDefaultNotebookRoute: string;
    syncLocalStorageWithCurrentNotebookId: () => void;
}

const useNotebooksRedirects = (): UseNotebooksRedirects => {
    const {
        lastVisitedNotebook,
        firstNotebookInList,
        resultObject: notebooks,
    } = useNotebooksAtom();
    const { currentNotebook } = useCurrentNotebook();
    const { push } = useHistory();
    const { lastVisitedNotebookId, setLastVisitedNotebookId } =
        useLastVisitedNotebook();

    const lastVisitedNotebookRoute = getNotebookRouteById(
        lastVisitedNotebook?.id
    );
    const firstNotebookInListRoute = getNotebookRouteById(
        firstNotebookInList?.id
    );
    const notebookLanderRoute = siteMap.notebooks.list;

    const redirectToDefaultNotebookRoute =
        lastVisitedNotebookRoute ??
        firstNotebookInListRoute ??
        notebookLanderRoute;

    const redirectToDefaultNotebook = () => {
        push(redirectToDefaultNotebookRoute);
    };

    const redirectToDefaultNotebookAfterDelete = (
        removedNotebookId: number
    ) => {
        if (currentNotebook?.id === removedNotebookId) {
            const firstNotebookIdExcludingRemovedNotebook = notebooks.filter(
                (notebook) =>
                    notebook.id !== removedNotebookId &&
                    notebook.id !== NotebookConstants.SharedPageNotebookId
            )[0]?.id;
            const route =
                getNotebookRouteById(firstNotebookIdExcludingRemovedNotebook) ??
                notebookLanderRoute;
            push(route);
        }
    };

    const syncLocalStorageWithCurrentNotebookId = useCallback(() => {
        if (
            currentNotebook &&
            currentNotebook.id &&
            lastVisitedNotebookId !== currentNotebook.id
        ) {
            setLastVisitedNotebookId(currentNotebook.id);
        }
    }, [currentNotebook, lastVisitedNotebookId, setLastVisitedNotebookId]);

    return {
        redirectToDefaultNotebook,
        redirectToDefaultNotebookAfterDelete,
        redirectToDefaultNotebookRoute,
        syncLocalStorageWithCurrentNotebookId,
    };
};

const getNotebookRouteById = (
    notebookId: number | undefined
): string | null | undefined =>
    notebookId
        ? RouteUtils.getUrl(siteMap.notebooks.notebook.detail, { notebookId })
        : undefined;
export default useNotebooksRedirects;
